<template>
  <section class="content">
    <admin-header
      title="Tariff Sets"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    />
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminBrandGroup',
    data () {
      return {
        newEntityScreen: 'Admin - Tariff Set',
        searchEntityScreen: 'Admin - Tariff Set search',
        filterEventName: 'admin-brand-group-filter',
        filterName: 'BrandGroupFilter',
        entityName: 'brand-group',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/BrandGroup/AdminBrandGroup.vue